// Generated by ReScript, PLEASE EDIT WITH CARE


let xsmall = "(min-width: 24rem)";

let small = "(min-width: 34rem)";

let medium = "(min-width: 48rem)";

let large = "(min-width: 64rem)";

let huge = "(min-width: 87rem)";

let massive = "(min-width: 100rem)";

function toMediaQuery(breakpoint) {
  if (breakpoint === "large") {
    return large;
  } else if (breakpoint === "xsmall") {
    return xsmall;
  } else if (breakpoint === "medium") {
    return medium;
  } else if (breakpoint === "small") {
    return small;
  } else if (breakpoint === "massive") {
    return massive;
  } else {
    return huge;
  }
}

export {
  xsmall,
  small,
  medium,
  large,
  huge,
  massive,
  toMediaQuery,
}
/* No side effect */
